(() => {
  const OVERLAY_CLASS = 'terms-gate-overlay';
  const PULSE_CLASS = 'is-pulse';
  const MISSING_CLASS = 'is-missing';

  function getCheckbox(target) {
    // 1) Drawer hat Vorrang
    const drawer = target.closest && target.closest('cart-drawer');
    if (drawer) return drawer.querySelector('[data-cart-terms-checkbox]');

    // 2) Normaler Warenkorb (nicht im Drawer)
    const normal = document.querySelector('[data-cart-terms-checkbox]:not(cart-drawer [data-cart-terms-checkbox])');
    if (normal) return normal;

    // 3) Fallback
    return document.querySelector('[data-cart-terms-checkbox]');
  }

  function pulse(cb) {
    if (!cb) return;

    const box = cb.closest('terms-checkbox') || cb.parentElement;
    if (!box) return;

    box.classList.add(MISSING_CLASS);
    box.classList.remove(PULSE_CLASS);
    void box.offsetWidth; // Reflow, damit Animation neu startet
    box.classList.add(PULSE_CLASS);

    setTimeout(() => box.classList.remove(PULSE_CLASS), 900);
  }

  function nudge(cb) {
    if (!cb) return;
    cb.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { cb.focus({ preventScroll: true }); } catch (e) {}
    pulse(cb);
  }

  function blockIfNeeded(e, target) {
    const cb = getCheckbox(target);
    if (!cb) return;

    if (!cb.checked) {
      e.preventDefault();
      e.stopPropagation();
      nudge(cb);
    }
  }

  // ---------- EXPRESS OVERLAY LOGIK ----------
  function findExpressContainer(scope) {
    return (
      scope.querySelector('.additional-checkout-buttons') ||
      scope.querySelector('.cart__dynamic-checkout-buttons') ||
      scope.querySelector('[data-shopify-buttoncontainer]') ||
      scope.querySelector('.shopify-cleanslate')
    );
  }

  function ensureOverlay(expressEl, cb) {
    if (!expressEl || !cb) return null;

    const cs = getComputedStyle(expressEl);
    if (cs.position === 'static') expressEl.style.position = 'relative';

    let overlay = expressEl.querySelector(`.${OVERLAY_CLASS}`);
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = OVERLAY_CLASS;

      const handler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        nudge(cb);
      };

      overlay.addEventListener('pointerdown', handler, { passive: false });
      overlay.addEventListener('click', handler, { passive: false });

      expressEl.appendChild(overlay);
    }

    overlay.style.display = cb.checked ? 'none' : 'block';
    return overlay;
  }

  function syncExpressOverlays() {
    // 1) Warenkorb-Seite
    const cartCb = document.querySelector('[data-cart-terms-checkbox]:not(cart-drawer [data-cart-terms-checkbox])');
    if (cartCb) {
      const express = findExpressContainer(document);
      ensureOverlay(express, cartCb);
    }

    // 2) Drawer
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const drawerCb = drawer.querySelector('[data-cart-terms-checkbox]');
      if (drawerCb) {
        const express = findExpressContainer(drawer);
        ensureOverlay(express, drawerCb);
      }
    }
  }

  function bootExpressWatcher() {
    syncExpressOverlays();

    const obs = new MutationObserver(() => syncExpressOverlays());
    obs.observe(document.documentElement, { childList: true, subtree: true });

    let tries = 0;
    const iv = setInterval(() => {
      syncExpressOverlays();
      tries += 1;
      if (tries > 40) clearInterval(iv);
    }, 250);
  }

  // ---------- CHECKOUT BLOCK ----------
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('button[name="checkout"], input[name="checkout"]');
      const link = e.target.closest('a[href^="/checkout"]');
      if (btn || link) blockIfNeeded(e, btn || link);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (form && form.querySelector('[name="checkout"]')) blockIfNeeded(e, form);
    },
    true
  );

  // Checkbox geändert → Overlay updaten
  document.addEventListener(
    'change',
    function (e) {
      if (e.target && (e.target.matches('[data-cart-terms-checkbox]') || e.target.closest('[data-cart-terms-checkbox]'))) {
        syncExpressOverlays();
      }
    },
    true
  );

  document.addEventListener('DOMContentLoaded', bootExpressWatcher);
  document.addEventListener('cart:updated', syncExpressOverlays);
})();